module.exports = __webpack_public_path__ + "static/media/assistante_full.95385b71.jpg";